export class CustomStyles {
    cssClass?: string;
    style?: string;
}
